import React from 'react';
import { Alert, Container, Spinner } from '@amzn/awsui-components-react';
import { Event, Shift } from '@amzn/red-velvet-api';
import { useLocalizedText } from '../../hooks/localizedText';
import {
  DISPLAY_ATTRIBUTES_TYPE,
  DISPLAY_COORDINATOR_INFO,
  DISPLAY_DATE_INFO,
  DISPLAY_LOCATION_INFO,
} from '../shifts/shiftInfo';
import { ShiftCard, ShiftHeader } from '../attendance/coordinator/shiftCard';

interface SignupSheetShiftHeaderProps {
  event?: Event;
  shift?: Shift;
  isLoading: boolean;
  isError: boolean;
}

export function SignupTableShiftHeader({
  event,
  shift,
  isLoading,
  isError,
}: SignupSheetShiftHeaderProps) {
  const { t } = useLocalizedText(['signup']);

  if (isError) {
    return <Alert type="error">{t('manageSignupsPage.errorLoadingEventShift')}</Alert>;
  }

  if (isLoading) {
    return (
      <Container>
        <Spinner />
        <span>{t('manageSignupsPage.loadingEventShift')}</span>
      </Container>
    );
  }

  if (!event || !shift) {
    return null;
  }

  const displayAttributes: DISPLAY_ATTRIBUTES_TYPE[] = [
    DISPLAY_LOCATION_INFO,
    DISPLAY_COORDINATOR_INFO,
    DISPLAY_DATE_INFO,
  ];

  return (
    <Container>
      <ShiftHeader event={event} />
      <ShiftCard event={event} shift={shift} displayAttributes={displayAttributes} />
    </Container>
  );
}
